import { render, staticRenderFns } from "./OpeningBalances.vue?vue&type=template&id=797e8070&scoped=true"
import script from "./OpeningBalances.vue?vue&type=script&lang=js"
export * from "./OpeningBalances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797e8070",
  null
  
)

export default component.exports